import React, { useRef, useEffect } from 'react';
import { InputAdornment, Typography, TextField } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { INPUT_TYPOGRAPHY_SX } from './inputTypography';
const AutocompleteField = React.forwardRef((props, ref) => {
    var _a;
    const inputRef = useRef(null);
    const [isFocused, setIsFocused] = React.useState(false);
    const google = window.google;
    const autocompleteRef = useRef(null);
    let isAddressSelected = false;
    let isBillingAddressSelected = false;
    useEffect(() => {
        const timer = setTimeout(() => {
            if (inputRef.current && window.google && window.google.maps && !autocompleteRef.current) {
                autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
                    componentRestrictions: { country: ["us", "ca"] },
                    fields: ['address_components', 'geometry'],
                    types: ["address"],
                });
                autocompleteRef.current.addListener('place_changed', () => {
                    var _a;
                    const place = (_a = autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.getPlace();
                    if (place && place.address_components) {
                        isAddressSelected = true;
                        if (props.id == 'Address') {
                            props.onPlaceSelected(place, props.id, props.CusIndex, isAddressSelected, false, props.valueObj);
                        }
                        else if (props.id == 'BillingAddress') {
                            isBillingAddressSelected = true;
                            props.onPlaceSelected(place, props.id, props.CusIndex, false, isBillingAddressSelected, props.valueObj);
                        }
                        else if (props.id == 'StreetName') {
                            props.onPlaceSelected(place, props.id, isAddressSelected);
                        }
                        else if (props.id == 'GuaAddress') {
                            props.onPlaceSelected(place, props.id, props.GuaIndex, isAddressSelected, props.valueObj);
                        }
                    }
                });
            }
        }, 100);
        return () => {
            var _a, _b, _c;
            clearTimeout(timer);
            if (autocompleteRef.current) {
                (_c = (_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.clearInstanceListeners(autocompleteRef.current);
                autocompleteRef.current = null;
            }
        };
    }, [props.id, props.CusIndex, props.GuaIndex]);
    const cstTextStyles = Object.assign(Object.assign({}, INPUT_TYPOGRAPHY_SX), { '& .MuiInputBase-root.Mui-disabled': {
            '& .MuiOutlinedInput-notchedOutline': {
                background: 'rgb(0 0 0 / 5%)',
            },
        }, '& .MuiInputBase-input': Object.assign(Object.assign({}, INPUT_TYPOGRAPHY_SX['& .MuiInputBase-input']), { backgroundColor: '#fff', borderRadius: '4px' }) });
    const inputAdornments = {};
    if (props.startAdornment) {
        inputAdornments.startAdornment = (React.createElement(InputAdornment, { position: "start", className: "startAdornment-input" },
            React.createElement(Typography, { variant: "body1" }, props.startAdornment)));
    }
    if (props.endAdornment) {
        inputAdornments.endAdornment = (React.createElement(InputAdornment, { position: "end" }, props.endAdornment));
    }
    return (React.createElement(TextField, { inputRef: inputRef, variant: "outlined", size: "small", label: props.isOcrPrefilled ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 3 } },
            React.createElement(CheckCircleIcon, { style: { fontSize: 15, color: '#2E7D32' } }),
            props.label,
            props.isMandatoryField && React.createElement("span", { style: { color: "#F00214" } }, " *"))) : props.isMandatoryField && props.label ? (React.createElement(React.Fragment, null,
            props.label,
            React.createElement("span", { style: { color: "#F00214" } }, " *"))) : (props.label), name: props.name, id: props.id, type: props.type, value: props.value || '', onChange: (e) => props.onChange(e), disabled: props.disabled, placeholder: props.placeholder, error: props.error, fullWidth: (_a = props.fullWidth) !== null && _a !== void 0 ? _a : true, inputProps: Object.assign({ maxLength: props.maxLength || 50, autoComplete: 'off', autoCorrect: 'off', autoCapitalize: 'off', spellCheck: false }, (props.inputProps || {})), InputProps: Object.keys(inputAdornments).length > 0 ? inputAdornments : undefined, onPaste: props.onPaste, onKeyDown: props.onKeyDown, onBlur: props.onBlur, helperText: props.error_message, className: `${props.disabled ? 'disable-fields' : ''} ${props.className || ''}`.trim(), FormHelperTextProps: { sx: { marginTop: 0 } }, InputLabelProps: {
            sx: {
                '&.MuiInputLabel-shrink': {},
            },
        }, sx: cstTextStyles }));
});
export default AutocompleteField;
